import { Outlet } from "react-router-dom";
import { Fragment } from "react";
import { ReactComponent as Logo } from '../../assets/crown.svg'
import ShopIcon from "../../components/shop-icon/shop-icon.component";
import CartDropdown from "../../components/card-dropdown/card-dropdown.component";
import { useSelector, useDispatch } from "react-redux"

import { NavigationContainer, LogoContainer, NavLink, NavLinks } from './navigation.styles.jsx'
import { selectCurrentUser } from "../../store/user/user.selector.js";
import { selectIsCartOpen } from '../../store/cart/cart.selector.js'
import { signOutStart } from "../../store/user/user.action.js";

const Navigation = () => {
  const dispatch = useDispatch()
  const isCartOpen = useSelector(selectIsCartOpen)

  const signOutUser = () => dispatch(signOutStart())

  const currentUser = useSelector(selectCurrentUser);
  return (
    <Fragment>
      <NavigationContainer>
        <LogoContainer to="/">
          <Logo className='logo'></Logo>
        </LogoContainer>
        <NavLinks>
          <NavLink to="/shop">
            Shop
          </NavLink>
          {
            currentUser ? (
              <NavLink as={"span"} className="nav-link" onClick={signOutUser}>Sign Out</NavLink>
            ) : (
              <NavLink to="/auth">SignIn</NavLink>
            )
          }
          <ShopIcon></ShopIcon>
        </NavLinks>
        {isCartOpen && <CartDropdown></CartDropdown>}
      </NavigationContainer>
      <Outlet />
    </Fragment>
  );
};

export default Navigation;
